import { useTranslation } from "react-i18next";
import React from "react";
import { changeGlobalMessageVisibility } from "../../../../../../axios/api/services";
import { toast } from "react-toastify";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/globalMessageControl";

const ChangeGlobalMessageVisibilityDialog = ({ filterFn }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.globalMessageControl.modals.changeVisibility;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "changeVisibility" }));
  };

  const onSuccess = (response) => {
    filterFn();
    handleCloseDialog();
    toast.success(t("m.create.globalMessage.success"));
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => changeGlobalMessageVisibility(id)}
      onSuccess={onSuccess}
      title={"t.email.globalMessage.activation.dialog"}
      message={"m.activation.email.globalMessage.warning.message"}
    />
  );
};

export default ChangeGlobalMessageVisibilityDialog;
